import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';
import { Logger } from '~~/helpers/logger';

type ViewItemParams = {
  sku: string;
  email?: string;
  userId?: string;
};

type ViewItemRequest = {
  locale: string;
  sku: string;
  cookie?: string;
  email?: string;
  user_id?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async ({ sku, email, userId }: ViewItemParams): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|viewItem SSR suppressed');
      
      }

      return Promise.resolve();
    
    }

    if (!sku) {

      return Promise.resolve();
    
    }

    const bloomreachCookieValue = getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE));

    const payload: ViewItemRequest = {
      locale: languageAndCountry,
      sku,
      cookie: bloomreachCookieValue,
    };

    if (email) {

      payload.email = email;
    
    }

    if (userId) {

      payload.user_id = userId;
    
    }

    return fetch('/cia/view-item', {
      method: 'POST',
      body: payload,
    });
  
  };

};
